import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import IconVerified from '../../../app/components/Icons/IconVerified';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { Filter, FilterContent, FilterHat, FilterTitle } from '@/components/custom/filter';

export default function Breadcrumbs(props) {
  const { data, actions, innerContent } = props;

  return (
    <Filter
      variant="plain"
      aria-label="breadcrumb"
      className="gap-0 md:fixed md:left-16 md:right-0 md:top-8 md:z-[105] md:mb-0 md:w-[calc(100vw-324px-64px)] md:overflow-hidden md:border-b-0 md:!pl-11 md:pb-0"
    >
      {data?.title && <FilterHat>{data?.title}</FilterHat>}

      <FilterContent>
        {data?.nav?.map((item, index, arr) => {
          const lastItem = index === arr.length - 1;

          return lastItem ? (
            <ButtonBack
              key={index}
              className="cursor-default"
              title={item?.name}
              disabled={!item?.isActive}
            >
              <ButtonBackContent>
                <FilterTitle>
                  {item?.name} {item?.['official-content'] && <IconVerified />}
                </FilterTitle>
              </ButtonBackContent>
            </ButtonBack>
          ) : (
            <ButtonBack
              key={index}
              title={item?.name}
              disabled={!item?.isActive}
              asChild
            >
              <Link to={item.route || '#'}>
                <ButtonBackContent>
                  <FilterTitle>
                    {item?.name} {item?.['official-content'] && <IconVerified />}
                  </FilterTitle>
                </ButtonBackContent>

                <IconWrapper size="sm">
                  <FiChevronLeft />
                </IconWrapper>
              </Link>
            </ButtonBack>
          );
        })}

        {innerContent && innerContent}
      </FilterContent>

      {actions && actions}
    </Filter>
  );
}
